import { VStack, Text, Pressable, HStack } from '@gluestack-ui/themed';
import { Icon } from '@repo/core/components/core/Icon';
import { MenuItemProps } from './types';
import { IconNames } from '@repo/core/components/core/Icon/types';

export const MenuItem = ({
  icon,
  label,
  fontColor = '$secondary500',
  iconColor = '$secondary500',
  onPress
}: MenuItemProps) => {
  return (
    <Pressable variant="ghost" onPress={onPress} borderRadius={8}>
      <HStack
        w={'$full'}
        alignItems="center"
        justifyContent="space-between"
        p="$3"
      >
        <HStack gap="$2" alignItems="center" justifyContent="center">
          <Icon name={icon as IconNames} size="sm" color={iconColor} />
          <Text
            color={fontColor}
            textAlign="center"
            fontSize={'$sm'}
            lineHeight={'$xl'}
            fontWeight={500}
          >
            {label}
          </Text>
        </HStack>

        <VStack
          w="$6"
          h="$6"
          alignItems="center"
          justifyContent="center"
          borderRadius={'$full'}
          pl={'$1.5'}
        >
          <Icon name={'chevron-right'} size="xs" color={'$secondary500'} />
        </VStack>
      </HStack>
    </Pressable>
  );
};
